import React from 'react'
import bg from 'images/personas/bg-information.jpg'

export default function InformationIntro() {
  return (
    <section className="section" data-anchor="the_information_intro">
      <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex relative">
        <div className="col-12 flex flex-column relative z1">
          <div className="flex flex-auto flex-center p4 sm-p0">
            <div className="flex flex-center flex-wrap mxn2">
              <div className="col-6 px2 sm-col-12 sm-mb3">
                <h2 className="persona-sub-title">What should you do with this information?</h2>
              </div>

              <div className="col-6 px2 sm-col-12 sm-mb3">
                <p className="fs-18">The report you generated on lussy.io visualizes up to date data about your audience to help you make better decisions about how to reach them and what to tell them.</p>
              </div>
            </div>
          </div>

          <div>
            <img alt="" className="block" src={bg} />
          </div>
        </div>
      </div>
    </section>
  );
}
